export default [

     {
          path: '/electronic-admission-setting',
          name: 'ElectronicAdmissionSetting',
          component: () => import("@/views/Page/ElectronicAdmissionSetting/ElectronicAdmissionSetting.vue"),
          meta: {
               title: 'Electronic Admission Setting',
          },
     }
];